import { render, staticRenderFns } from "./IconoEnPreparacion.vue?vue&type=template&id=6d1ecc14&"
import script from "./IconoEnPreparacion.vue?vue&type=script&lang=js&"
export * from "./IconoEnPreparacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports